__turbopack_context__.v({
  "label": "FormSelect-module-scss-module__ctEalq__label",
  "select": "FormSelect-module-scss-module__ctEalq__select",
  "select-arrow": "FormSelect-module-scss-module__ctEalq__select-arrow",
  "select-container": "FormSelect-module-scss-module__ctEalq__select-container",
  "select-error": "FormSelect-module-scss-module__ctEalq__select-error",
  "select-wrapper": "FormSelect-module-scss-module__ctEalq__select-wrapper",
});
